var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundLines = function SvgSoundLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 271 94"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M47.672 1v92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M52.69 10.583v72.834"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__c)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M57.709 14.417v65.166"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__d)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M62.727 6.75v80.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__e)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M67.746 2.917v88.166"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__f)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M72.764 18.22v57.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__g)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M77.783 27.804v38.333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__h)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M82.801 23.97v47.917"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__i)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M87.82 33.554v28.75"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__j)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M92.838 37.387v19.167"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__k)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M97.857 29.72v34.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__l)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M102.875 25.887v44.084"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__m)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M107.894 31.637v32.584"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__n)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M112.912 31.637v32.584"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__o)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M189.194 16.517v60.977",
    opacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__p)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M194.212 8.894v76.223",
    opacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__q)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M199.23 5.083v83.845",
    opacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__r)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M204.249 24.139v45.733",
    opacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M209.268 27.92v38.112",
    opacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__s)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M214.286 24.11v47.638",
    opacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__t)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M219.305 33.637v28.584",
    opacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__u)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M224.323 37.449v19.055",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__v)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M229.342 29.826v34.3",
    opacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__w)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M234.36 26.015v43.828",
    opacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__x)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M239.379 31.732v32.394",
    opacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__y)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M244.397 31.732v32.394",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__z)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M183.171 3.722v87.922",
    opacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__A)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M178.153 13.279v68.808",
    opacity: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__B)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M173.134 17.102v61.163",
    opacity: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__C)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M168.116 9.456V85.91",
    opacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__D)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M163.098 5.633v84.1",
    opacity: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__E)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M158.079 18.984v57.34"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__F)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M153.061 28.54v38.227"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__G)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M148.042 24.718v47.784"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__H)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M143.024 34.275v28.67"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__I)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M138.004 38.097v19.114"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__J)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M132.986 30.452v34.404"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__K)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M127.968 26.629V70.59"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__L)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M122.95 22.806v51.607"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__M)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M117.931 40.009V57.21"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__N)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M269.498 39.082v19.056",
    opacity: 0.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__O)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M264.48 31.46v34.3",
    opacity: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__P)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M259.461 27.649v43.827",
    opacity: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__Q)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M254.443 23.837v51.45",
    opacity: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__R)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M249.424 40.987v17.15",
    opacity: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__S)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M41.65 20.026v57.167"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__T)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M36.631 29.554v38.111"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__U)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M31.613 25.743v47.639"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__V)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M26.594 35.27v28.584"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__W)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21.576 39.082v19.055"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__X)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16.557 31.46v34.3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__Y)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.539 27.648v43.828"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__Z)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.52 23.837v51.45"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#SoundLines_svg__aa)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1.502 40.987v17.15"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__a",
    x1: 47.672,
    x2: 47.672,
    y1: 1,
    y2: 93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__b",
    x1: 52.69,
    x2: 52.69,
    y1: 10.583,
    y2: 83.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__c",
    x1: 57.709,
    x2: 57.709,
    y1: 14.417,
    y2: 79.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__d",
    x1: 62.727,
    x2: 62.727,
    y1: 6.75,
    y2: 87.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__e",
    x1: 67.746,
    x2: 67.746,
    y1: 2.917,
    y2: 91.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__f",
    x1: 72.764,
    x2: 72.764,
    y1: 18.221,
    y2: 75.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__g",
    x1: 77.783,
    x2: 77.783,
    y1: 27.804,
    y2: 66.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__h",
    x1: 82.801,
    x2: 82.801,
    y1: 23.971,
    y2: 71.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__i",
    x1: 87.82,
    x2: 87.82,
    y1: 33.554,
    y2: 62.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__j",
    x1: 92.838,
    x2: 92.838,
    y1: 37.387,
    y2: 56.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__k",
    x1: 97.857,
    x2: 97.857,
    y1: 29.721,
    y2: 64.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__l",
    x1: 102.875,
    x2: 102.875,
    y1: 25.887,
    y2: 69.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__m",
    x1: 107.894,
    x2: 107.894,
    y1: 31.637,
    y2: 64.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__n",
    x1: 112.912,
    x2: 112.912,
    y1: 31.637,
    y2: 64.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__o",
    x1: 189.194,
    x2: 189.194,
    y1: 16.517,
    y2: 77.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__p",
    x1: 194.212,
    x2: 194.212,
    y1: 8.894,
    y2: 85.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__q",
    x1: 199.23,
    x2: 199.23,
    y1: 5.083,
    y2: 88.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__r",
    x1: 204.249,
    x2: 204.249,
    y1: 24.139,
    y2: 69.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__s",
    x1: 214.286,
    x2: 214.286,
    y1: 24.11,
    y2: 71.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__t",
    x1: 219.305,
    x2: 219.305,
    y1: 33.637,
    y2: 62.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__u",
    x1: 224.323,
    x2: 224.323,
    y1: 37.449,
    y2: 56.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__v",
    x1: 229.342,
    x2: 229.342,
    y1: 29.826,
    y2: 64.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__w",
    x1: 234.36,
    x2: 234.36,
    y1: 26.015,
    y2: 69.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__x",
    x1: 239.379,
    x2: 239.379,
    y1: 31.732,
    y2: 64.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__y",
    x1: 244.397,
    x2: 244.397,
    y1: 31.732,
    y2: 64.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__z",
    x1: 183.171,
    x2: 183.171,
    y1: 3.722,
    y2: 91.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__A",
    x1: 178.153,
    x2: 178.153,
    y1: 13.279,
    y2: 82.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__B",
    x1: 173.134,
    x2: 173.134,
    y1: 17.102,
    y2: 78.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__C",
    x1: 168.116,
    x2: 168.116,
    y1: 9.456,
    y2: 85.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__D",
    x1: 163.098,
    x2: 163.098,
    y1: 5.633,
    y2: 89.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__E",
    x1: 158.079,
    x2: 158.079,
    y1: 18.984,
    y2: 76.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__F",
    x1: 153.061,
    x2: 153.061,
    y1: 28.54,
    y2: 66.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__G",
    x1: 148.042,
    x2: 148.042,
    y1: 24.718,
    y2: 72.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__H",
    x1: 143.024,
    x2: 143.024,
    y1: 34.275,
    y2: 62.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__I",
    x1: 138.004,
    x2: 138.004,
    y1: 38.097,
    y2: 57.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__J",
    x1: 132.986,
    x2: 132.986,
    y1: 30.452,
    y2: 64.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__K",
    x1: 127.968,
    x2: 127.968,
    y1: 26.629,
    y2: 70.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__L",
    x1: 122.95,
    x2: 122.95,
    y1: 22.806,
    y2: 74.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__M",
    x1: 117.931,
    x2: 117.931,
    y1: 40.008,
    y2: 57.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__N",
    x1: 269.498,
    x2: 269.498,
    y1: 39.082,
    y2: 58.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__O",
    x1: 264.48,
    x2: 264.48,
    y1: 31.459,
    y2: 65.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__P",
    x1: 259.461,
    x2: 259.461,
    y1: 27.648,
    y2: 71.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__Q",
    x1: 254.443,
    x2: 254.443,
    y1: 23.837,
    y2: 75.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__R",
    x1: 249.424,
    x2: 249.424,
    y1: 40.987,
    y2: 58.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__S",
    x1: 41.65,
    x2: 41.65,
    y1: 20.026,
    y2: 77.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__T",
    x1: 36.631,
    x2: 36.631,
    y1: 29.554,
    y2: 67.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__U",
    x1: 31.613,
    x2: 31.613,
    y1: 25.743,
    y2: 73.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__V",
    x1: 26.594,
    x2: 26.594,
    y1: 35.271,
    y2: 63.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__W",
    x1: 21.576,
    x2: 21.576,
    y1: 39.082,
    y2: 58.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__X",
    x1: 16.557,
    x2: 16.557,
    y1: 31.459,
    y2: 65.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__Y",
    x1: 11.539,
    x2: 11.539,
    y1: 27.648,
    y2: 71.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__Z",
    x1: 6.52,
    x2: 6.52,
    y1: 23.837,
    y2: 75.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundLines_svg__aa",
    x1: 1.502,
    x2: 1.502,
    y1: 40.987,
    y2: 58.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })))));
};
export default SvgSoundLines;